//@flow
// import React from 'react'
// import ReactDOM from 'react-dom'
// import {css} from 'linaria'
// import './dynamic'
// import './graphite/dynamic'
// import './flow/dynamic'
// import './logs/dynamic'
// import View from './view'
// import view from './canvas/view'
// import './dataflow'
// import './canvas/holeLoop'
import './canvas/wave'

// const body = document.getElementById('root')
// window.addEventListener(
//   'touchmove',
//   event => {
//     event.preventDefault()
//   },
//   {passive: false},
// )
// if (body) {
//   body.className = css`
//     display: contents;
//     :global() {
//       body {
//         overscroll-behavior: none;
//         padding: 0;
//         margin: 0;
//         -webkit-overflow-scrolling: touch;
//         /* position: relative; */
//       }
//       body,
//       html {
//         height: 100vh;
//       }
//     }
//   `
//   body.addEventListener(
//     'touchmove',
//     (event: TouchEvent) => {
//       event.stopPropagation()
//     },
//     false,
//   )
//   ReactDOM.render(<View />, body)
// }
